module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_06_stay-b54c384be93916828e55b7012e2dfc04.jpg";